import React, {useState} from "react";
import right from "./assets/caret-right.svg";
import GetYouProjects from "../../../GlobalComponents/GetYouProjects/GetYouProjects";
const LearnAbout = () => {
  return (
    <div className="container">
      <div className="container-1240 mt-[128px]">
        <div className="flex flex-col md:flex-row md:items-center gap-[10px] md:gap-[18px] mb-[24px]">
          <h2 className="text-res-lg font-bold">
            Learn about <span className="text-main-green">R34P</span> DAO
          </h2>
          <button className="flex gap-[3px] items-center">
            <p className="text-res-sm font-bold text-[#797979]">
              Explore our Blog
            </p>
            <img src={right} alt="" />
          </button>
        </div>

        <GetYouProjects></GetYouProjects>
      </div>
    </div>
  );
};

export default LearnAbout;
